import script from "./StartOwnSubscriptionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StartOwnSubscriptionDialog.vue?vue&type=script&setup=true&lang=js"

import "./StartOwnSubscriptionDialog.vue?vue&type=style&index=0&id=94d281e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d281e4"]])

export default __exports__